import axios from 'axios'
import { toast } from 'react-toastify';
import { appRouteDetection, getCookie } from '../components/helper';
import requestConfigs, { getPath, getRequestRequirement } from './requestConfig'
const baseUrl = process.env.REACT_APP_API_ENDPOINT + requestConfigs.prefix + requestConfigs.version;
const apiCoreCaller = axios.create({
  baseURL: process.env.REACT_APP_CORE_API_ENDPOINT,
  headers: { 'Accept': 'application/json' }
})
const _axios = axios.create({ baseURL: baseUrl })

// let headers = {
//     ContentType: 'application/x-www-form-urlencoded',
//     Origin: 'http://localhost:4200',
//     Referer: 'http://localhost:4200'  
// }
_axios.defaults.headers.Accept = 'application/json'

// _axios.defaults.baseURL = baseUrl

// _axios.defaults.headers.CacheControl = 'no-cache';
_axios.defaults.headers.common["Cache-Control"] = "no-cache";
_axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('i18nextLng')
apiCoreCaller.defaults.headers.common["Cache-Control"] = "no-cache";
apiCoreCaller.defaults.headers.common['Accept-Language'] = localStorage.getItem('i18nextLng')
apiCoreCaller.defaults.withCredentials = true

const clientError = "ورودی ها به صورت درست به سرور ارسال نشده است"
const serverError = "سرور در اجرای درخواست شما با مشکل مواجه شده است"
const notExeAPI = " در خواست از سرور با مشکل مواجه شده است"
const NotCallApi = " درخواست شما برای سرور ارسال نشد"

apiCoreCaller.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('token')
    // const portalCookie = getCookie("token") ? JSON.parse(getCookie("token")) : getCookie("token")

    // if (portalCookie && window?.location?.href?.indexOf("/react") > -1) {
    //   localStorage.setItem("portalUser", portalCookie.access_token)
    //   config.headers.Authorization = `Bearer ${portalCookie.access_token}`
    // } else if (accessToken) {
    //   config.headers.Authorization = `Bearer ${accessToken}`
    // }
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`

    }


    return config
  },
  (err) =>
    Promise.reject(err),
)
apiCoreCaller.interceptors.response?.use(
  response => response,
  (err) => {
    if (err?.response?.status === 400) {
      return Promise.reject(err.response?.data)
    }
    if (err?.response?.status === 401) {

      console.log("401")

      localStorage.removeItem("dsTokenExpiration")
      localStorage.removeItem("token")
      localStorage.removeItem("portalExtraInfo")

      window.location = "/#/login"
      // if (window?.location?.href?.indexOf("/react") > -1) {
      //   window.location.href = 'login.html';

      // } else {
      //   window.location = "/#/login"

      // }

    }
    else if ((err.response?.status === 400 || err.response?.status === 404)) {
      if (err.response?.data) {
        return Promise.reject(err.response?.data)
      }
      else {
        return Promise.reject(clientError)
      }
    }
    else if ((err.response?.status === 500)) {
      return Promise.reject(serverError)
    }
    else {
      return Promise.reject(NotCallApi)
    }


    if (requirement.action.enable_message) {

      if (err?.response?.data?.errors) {
        Object.keys(err?.response?.data?.errors).forEach(item => {
          err?.response?.data?.errors[item].forEach(error => {
            toast.error(error)
          })
        })
      } else {
        toast.error(err.response && err.response?.data && err.response?.data.error
          ? err.response?.data.error
          : "بروز خطا در عملیات")
      }


    }
    return { ...err, option: requirement.action }
  },
)

let requirement = {};

_axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('token')
    // const portalCookie = getCookie("token") ? JSON.parse(getCookie("token")) : getCookie("token")

    // if (portalCookie && window?.location?.href?.indexOf("/react") > -1) {
    //   localStorage.setItem("portalUser", portalCookie.access_token)
    //   config.headers.Authorization = `Bearer ${portalCookie.access_token}`
    // } else if (accessToken) {
    //   config.headers.Authorization = `Bearer ${accessToken}`
    // }
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`

    }



    return config
  },
  (err) =>
    Promise.reject(err),
)
_axios.defaults.withCredentials = true
_axios.interceptors.response?.use(
  response => response,
  (err) => {
    if (err?.response?.status === 401) {
      console.log("401")

      localStorage.removeItem("portalUser")
      localStorage.removeItem("token")
      if (window?.location?.href?.indexOf("/react") > -1) {
        window.location.href = 'login.html';

      } else {
        window.location = "/#/login"

      }

    }
    else if ((err.response?.status === 400 || err.response?.status === 404)) {
      if (err.response?.data) {
        return Promise.reject(err.response?.data)
      }
      else {
        return Promise.reject(clientError)
      }
    }
    else if ((err.response?.status === 500)) {
      return Promise.reject(serverError)
    }
    else {
      return Promise.reject(NotCallApi)
    }
    if (requirement.action.enable_message) {

      if (err?.response?.data?.errors) {
        Object.keys(err?.response?.data?.errors).forEach(item => {
          err?.response?.data?.errors[item].forEach(error => {
            toast.error(error)
          })
        })
      } else {
        toast.error(err.response && err.response?.data && err.response?.data.error
          ? err.response?.data.error
          : "بروز خطا در عملیات")
      }


    }
    return { ...err, option: requirement.action }
  },
)

export default _axios

export const apiRequest = async (path, params = {}, pathParams = '', isCoreApi) => {
  let caller = _axios;
  if (isCoreApi) {
    caller = apiCoreCaller

  }
  //  else {
  //   _axios.defaults.baseURL = process.env.REACT_APP_CORE_API_ENDPOINT;

  // }

  requirement = getRequestRequirement(path);

  switch (requirement.action.method) {

    case 'post':
      {

        if (path === 'CustomerAttachment.getCustomerAttachmentById' || path === 'CallReportNote.GetCallReportDetails' || path === 'LineReservation.TryReserveRequestedLines') {
          caller.defaults.headers.post['Content-Type'] = 'application/json';
        }

        const response = await caller.post(requirement.path + pathParams, params)


        if ((response?.status === 200 || response?.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response?.status === 200 || response?.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }

    case 'get':

      {
        const response = await caller.get(requirement.path + pathParams, params)

        if ((response?.status === 200 || response?.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response?.status === 200 || response?.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    case 'put':
      {
        const response = await caller.put(requirement.path + pathParams, params)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response.status === 200 || response.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    case 'patch':
      {

        const response = await caller.patch(requirement.path + pathParams, params)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response.status === 200 || response.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    case 'delete':
      {
        const response = await caller.delete(requirement.path + pathParams, params)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response.status === 200 || response.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    default:
      throw "Method not found";
  }
}


export const streamServerURL = (window.location.href.indexOf("localhost") === -1 && window.location.href.indexOf("portal.dev") === -1) ?
  'https://stream.daftareshoma.com/' : 'https://stream.dev.daftareshoma.com/'

export const serverUrl = window.location.href.indexOf("localhost") > -1 ? 'http://coreapi.dev.daftareshoma.com/' :
  window.location.href.indexOf("portaldev") > -1 || window.location.href.indexOf("rahimi") > -1 || window.location.href.indexOf("tebyan") > -1 ? 'https://coreapi.dev.daftareshoma.com/' : 'https://coreapi.daftareshoma.com/'

export const replaceUrl = "https://stream.daftareshoma.com"
export const insteadUrl = "https://stream.daftareshoma.com:8443"

export const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB
export { apiCoreCaller }
export const switchBaseUrl = (_axios, isCoreApi) => {
  _axios.defaults.baseURL = isCoreApi ? process.env.REACT_APP_CORE_API_ENDPOINT : process.env.REACT_APP_API_ENDPOINT;
}
